import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PageSeo } from '../components/PageSeo';
import { SubpageLayout } from '../components/SubpageLayout';
import { HISTORY_IMAGE_SRC } from '../data/historyContent';

/**
 * Tarihçe — URL: /history
 */
export function HistoryPage() {
    const { t } = useTranslation();

    const paragraphs = useMemo(() => {
        const raw = t('history.paragraphs', { returnObjects: true });
        return Array.isArray(raw) ? raw : [];
    }, [t]);

    return (
        <>
            <PageSeo
                title={`${t('history.title')} — ${t('header.rotaryAlt')}`}
                description={t('seo.history')}
            />
            <SubpageLayout
                title={t('history.title')}
                subtitle={t('history.subtitle')}
                contentClassName="history-page"
            >
            <div className="row g-4 g-xl-5 align-items-start">
                <div className="col-lg-6">
                    <figure className="history-figure mb-0">
                        <img
                            src={HISTORY_IMAGE_SRC}
                            alt={t('history.imageAlt')}
                            className="history-hero-img"
                            loading="lazy"
                            decoding="async"
                        />
                    </figure>
                </div>
                <div className="col-lg-6">
                    <div className="history-prose">
                        {paragraphs.map((text, i) => (
                            <p key={i} className="history-prose-p mb-0">
                                {text}
                            </p>
                        ))}
                    </div>
                </div>
            </div>
        </SubpageLayout>
        </>
    );
}
